<app-input-switch class="pn-table-switch"
                  offLabel="{{'admin.partNumbers.create-modal.tools.allTools' | translate}}"
                  onLabel="{{'admin.partNumbers.create-modal.tools.onlySelected' | translate}}"
                  [inline]="true"
                  [(ngModel)]="displayOnlySelected">
</app-input-switch>
<app-part-number-tools-table
    class="tools"
    [toolsGrouped]="this.displayOnlySelected ? this.selectedTools : this.tools"
    [selectedTools]="selectedTools"
    [isLoading]="loading"
    [readonly]="isReadOnly()"
    [tableConfig]="this.displayOnlySelected ? this.selectedToolsConfig: this.toolConfig"
    [showFilters]="!this.displayOnlySelected"
    [filtersToggle]="!this.displayOnlySelected"
    [showPagination]="!this.displayOnlySelected"
    [showGroupFilters]="false"
    [definedGroupers]="false"
    [showGroupers]="false"
    [isFilterExpanded]="false"
    (sortChange)="onToolsSortChange($event)"
    (filterChange)="onToolsFilterChange($event)"
    (filterGroupChange)="onToolsFilterGroupChange($event)"
    (groupChange)="onToolsGroupChange($event)"
    (pageChange)="onToolsPageChange($event)"
    (onToolClicked)="onToolClicked($event)">
</app-part-number-tools-table>
